import { SymbolType } from '@/containers/symbols/SymbolType'
import { SymbolsAnimationFactory } from './SymbolsAnimationFactory'
import { SymbolContainerData } from '@/modules'

export class LowValueSymbolsFactory extends SymbolsAnimationFactory {
    /** Spine clip prefix inside the shared `lv` skeleton. */
    private static readonly LETTER_BY_INDEX: Record<number, string> = {
        [SymbolType.LP_1]: 'a',
        [SymbolType.LP_2]: 'k',
        [SymbolType.LP_3]: 'q',
        [SymbolType.LP_4]: 'j',
    }

    public getAnimationResource(): string {
        return 'lv'
    }

    public getAnimationLabel(symbolData: SymbolContainerData, state: string): string {
        const letter = LowValueSymbolsFactory.LETTER_BY_INDEX[symbolData?.index]
        if (!letter) {
            return null
        }

        // Spine clips are bare letters for win (a/k/q/j) — no `_win` suffix.
        if (state === 'win') {
            return letter
        }

        if (state === 'land' || state === 'landing') {
            return `${letter}_in`
        }

        if (state === 'out') {
            return `${letter}_out`
        }

        return null
    }
}
